export default function(selector = '#rental_prop_persons') {
    const quantityOfGuests = document.querySelector(selector);
    if (!quantityOfGuests) {
        return false;
    }

    return quantityOfGuests;
}